import { Grid, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { formatarCPFCNPJ, formatarInputValorMonetário, formatarTelefone } from "../../../../../helpers/masks";
import { validarTelefone } from "../../../../../helpers/validarTelefone";

export default function FormIncluirCooperado() {

    const { control } = useFormContext();

    return (
        <Grid container spacing={2} mt={1}>
            <Grid size={{ xs: 6 }}>
                <Controller
                    name="publico_nome"
                    control={control}
                    rules={{ required: "Campo obrigatório" }}
                    render={({ field, fieldState: { error, invalid } }) => {
                        return (
                            <TextField
                                {...field}
                                required
                                error={invalid}
                                label="Nome"
                                fullWidth
                                value={field.value}
                                onChange={(e) => field.onChange(e.target.value)}
                                slotProps={{ htmlInput: { maxLength: 40 } }}
                                helperText={error ? error.message : ""}
                            />
                        );
                    }}
                />
            </Grid>
            <Grid size={{ xs: 6 }}>
                <Controller
                    name="email"
                    control={control}
                    render={({ field, fieldState: { error, invalid } }) => {
                        return (
                            <TextField
                                {...field}
                                error={invalid}
                                label="Email"
                                autoComplete="email"
                                fullWidth
                                value={field.value}
                                onChange={(e) => field.onChange(e.target.value)}
                                slotProps={{ htmlInput: { maxLength: 45 } }}
                                helperText={error ? error.message : ""}
                            />
                        );
                    }}
                />
            </Grid>
            <Grid size={{ xs: 4 }}>
                <Controller
                    name="cpf_cnpj"
                    control={control}
                    rules={{ required: "Campo obrigatório" }}
                    render={({ field, fieldState: { error, invalid } }) => {
                        return (
                            <TextField
                                {...field}
                                required
                                error={invalid}
                                label="CPF/CNPJ"
                                fullWidth
                                value={field.value}
                                onChange={(e) => field.onChange(formatarCPFCNPJ(e.target.value))}
                                slotProps={{ htmlInput: { maxLength: 17 } }}
                                helperText={error ? error.message : ""}
                            />
                        );
                    }}
                />
            </Grid>

            <Grid size={{ xs: 4 }}>
                <Controller
                    name="telefone"
                    control={control}
                    rules={{ required: "Campo obrigatório",
                        validate: (value) => {
                            const telefoneValido = validarTelefone(value);
                            return telefoneValido || "Telefone inválido";
                        }
                     }}
                    render={({ field, fieldState: { error, invalid } }) => {
                        return (
                            <TextField
                                {...field}
                                required
                                error={invalid}
                                label="Telefone"
                                autoComplete="telefone"
                                fullWidth
                                value={field.value}
                                onChange={(e) => field.onChange(formatarTelefone(e.target.value))}
                                slotProps={{ htmlInput: { maxLength: 45 } }}
                                helperText={error ? error.message : ""}
                            />
                        );
                    }}
                />
            </Grid>
            <Grid size={{ xs: 4 }}>
                <Controller
                    name="limite_desejado"
                    control={control}
                    rules={{ required: "Campo obrigatório" }}
                    render={({ field, fieldState: { error, invalid } }) => {
                        return (
                            <TextField
                                {...field}
                                required
                                error={invalid}
                                label="Limite desejado"
                                fullWidth
                                value={field.value}
                                onChange={(e) => field.onChange(formatarInputValorMonetário(e.target.value))}
                                helperText={error ? error.message : ""}
                            />
                        );
                    }}
                />
            </Grid>
            <Grid size={{ xs: 12 }}>
                <Controller
                    name="justificativa"
                    control={control}
                    render={({ field }) => {
                        return (
                            <TextField
                                {...field}
                                multiline
                                rows={3}
                                label="Justificativa"
                                fullWidth
                                value={field.value}
                                onChange={(e) => field.onChange(e.target.value)}
                            />
                        );
                    }}
                />
            </Grid>
        </Grid>
    )
}
